export default __webpack_public_path__ + "static/media/emptyPrevious.0fdbeb90.svg";